var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ConfirmOperator',{staticClass:"no-border",attrs:{"type":"primary","iconType":"md-exit","iconSize":"18","text":"退出登录","title":"退出登录","content":_vm.content}})
}
var staticRenderFns = []

export { render, staticRenderFns }